package tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import tta.destinigo.talktoastro.shared.data.CommonResponse

@Serializable
data class JoinQueueResponse(
    @SerialName("data")val data: JoinQueueData? = null
):CommonResponse()
